import React, { useEffect, useState } from 'react';
import { ReactComponent as HutricsLogoColor } from 'svg/hutrics-logo-color.svg';
import { Form, Stack } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from 'providers/auth-provider';
import { validate } from 'uuid';
import { clearGlobalStore } from '../../utils/global-storage';
import { getLoginPrompts } from '../../api/client';
import LogoLoader from '../../components/reports/shared/results/logo-loader';

const styles = {
  group: {
    paddingBottom: '2em',
  },
  logo: {
    paddingBottom: '2em',
    width: '50%',
    marginWidth: 'auto',
  },
};

function LoginForm() {
  const { login, loadSession } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showPage, setShowPage] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameLabel, setUsernameLabel] = useState('User Name');
  const [usernamePlaceholder, setUsernamePlaceholder] = useState('Enter your user name');
  const [passwordLabel, setPasswordLabel] = useState('Password');
  const [passwordPlaceholder, setPasswordPlaceholder] = useState('Enter your password');
  const [clientIdentifier, setClientIdentifier] = useState('');
  const [clientId, setClientId] = useState(null);
  const [clientSlug, setClientSlug] = useState(null);
  const [customLogo, setCustomLogo] = useState(false);

  const { slug } = useParams();
  const cid = searchParams.get('cid');
  const admin = searchParams.get('admin');

  const submitLogin = (event) => {
    event.preventDefault();
    let clientIdOrSlug;
    let isClientId = true;
    if (clientId || clientSlug) {
      clientIdOrSlug = clientId;
      if (clientSlug) {
        clientIdOrSlug = clientSlug;
        isClientId = false;
      }
    } else {
      clientIdOrSlug = clientIdentifier;
      if (!validate(clientIdentifier)) {
        isClientId = false;
      }
    }
    login(clientIdOrSlug, isClientId, username, password, (success) => {
      if (success) {
        const from = location.pathname || '/';
        navigate(from, { replace: true });
      }
    });
  };

  useEffect(() => {
    if (slug) {
      const img = new Image();
      const logoPath = `/client/${slug}/login-logo.png`;

      img.onload = () => {
        setCustomLogo(true);
      };

      img.src = logoPath;
    }
  }, [slug]);

  useEffect(() => {
    if (admin === null) {
      const prompts = getLoginPrompts(slug, cid);
      if (prompts) {
        setUsernameLabel(prompts.usernameLabel);
        setUsernamePlaceholder(prompts.usernamePlaceholder);
        setPasswordLabel(prompts.passwordLabel);
        setPasswordPlaceholder(prompts.passwordPlaceholder);
      }
    }
    loadSession((authData) => {
      let sessionCid;
      let sessionSlug;
      if (authData) {
        sessionCid = authData.clientId;
        sessionSlug = authData.slug;
      }

      if (cid) {
        sessionCid = cid;
        if (authData?.clientId && authData.clientId !== cid) {
          clearGlobalStore();
        }
      }
      if (slug) {
        sessionSlug = slug;
        if (authData?.slug && authData.slug !== slug) {
          clearGlobalStore();
        }
      }

      setClientId(sessionCid);
      setClientSlug(sessionSlug);

      setShowPage(true);
    });
  }, [cid, loadSession, slug]);

  return (
    <>
      {showPage && (
        <Stack gap={1} className="col-md-5 mx-auto h-100 justify-content-center w-50">
          <div className="pb-2 mx-auto w-50">
            <LogoLoader slug={slug} fileName={'login-logo.png'} />
          </div>
          <Form className="mx-auto w-75" onSubmit={(event) => submitLogin(event)}>
            <Form.Group style={styles.group}>
              {!clientId && !clientSlug && (
                <div className="pb-2">
                  <Form.Label>Client Identifier</Form.Label>
                  <Form.Control
                    id="username"
                    type="text"
                    placeholder="Enter client identifier"
                    onChange={(event) => setClientIdentifier(event.target.value)}
                  />
                </div>
              )}
              <div className="pb-2">
                <Form.Label>{usernameLabel}</Form.Label>
                <Form.Control
                  id="username"
                  type="text"
                  placeholder={usernamePlaceholder}
                  onChange={(event) => setUsername(event.target.value)}
                />
              </div>
              <Form.Label>{passwordLabel}</Form.Label>
              <Form.Control
                id="password"
                type="password"
                placeholder={passwordPlaceholder}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
          <div className="mx-auto pt-2 text-center">
            {customLogo && (
              <p className="mb-3">
                Powered by <HutricsLogoColor style={{ height: '32px', width: 'auto', verticalAlign: 'middle' }} />
              </p>
            )}
            <p>
              Need Help?{' '}
              <a href="mailto:help@hutrics.com" style={{ color: 'blue', textDecoration: 'underline' }}>
                help@hutrics.com
              </a>
            </p>
          </div>
        </Stack>
      )}
      {!showPage && <div />}
    </>
  );
}

export default LoginForm;
